import { getPatientBatteryInformation } from "app/services/dashboard/patientAnalyticService";
import { useDispatch, useSelector } from "react-redux";

import { useEffect, useRef } from "react";
import { showToast } from "utils/toast";

import {
  setBatteryInformation,
  setDownloadingModalText,
  setShowBatteryInformationModal,
  setIsDownloading,
  setSelectedTemplate,
  setSelectedDocument,
  setShowNoShowEmailModal,
  setLetterNextSendDate,
  setLetterNextSendDateModal,
} from "app/store/patientProfile/documents/slice/patientProfileDocumentSlice";
import {
  useFetchLetterTemplatesQuery,
  useFetchNoShowLettersQuery,
} from "app/store/patientProfile/documents/api/patientProfileDocumentApi";
import useDocuments from "../useDocuments";
import { getLetterNextSend } from "app/services/transmission/letter_templates";

const useDocumentTitle = () => {
  const anchorRef = useRef(null);
  const noShowAnchorRef = useRef(null);
  const dispatch = useDispatch();

  const { selectedTemplate } = useSelector(
    (state) => state.patientProfileDocument
  );

  useEffect(() => {}, [selectedTemplate]);

  const { profile, reportId } = useSelector((state) => state.transmission);
  const { currentUser } = useSelector((state) => state.auth);

  const { isLetterTemplateMenu, isNoShowLetterMenu } = useSelector(
    (state) => state.patientProfileDocument
  );

  const { data: letterTemplates } = useFetchLetterTemplatesQuery(
    profile?.patientId
  );

  const { data: nowShowLetters } = useFetchNoShowLettersQuery(
    profile?.patientId
  );

  const { generateTemplate } = useDocuments();

  const handleTemplateSelection = async (template) => {
    dispatch(setSelectedTemplate(template));
    try {
      if (template.show_battery) {
        dispatch(setDownloadingModalText("Fetching battery information..."));
        dispatch(setIsDownloading(true));
        const batteryInfo = await getPatientBatteryInformation(
          profile.patientId,
          reportId
        );
        dispatch(setBatteryInformation(batteryInfo));
        dispatch(setShowBatteryInformationModal(true));
        return;
      }

      if (template?.custom_next_send) {
        dispatch(setDownloadingModalText("Calculating next send date..."));
        dispatch(setIsDownloading(true));

        const nextSendInfo = await getLetterNextSend({
          templateId: template._id,
          patientId: profile.patientId,
        });

        dispatch(setLetterNextSendDate(nextSendInfo?.data?.nextSendDate));
        dispatch(setLetterNextSendDateModal(true));
        return;
      }
      await generateTemplate({ template });
    } catch (error) {
      showToast({ message: error.message, type: "error" });
    } finally {
      dispatch(setIsDownloading(false));
    }
  };

  const handleNoShowTemplateSelection = async (template) => {
    try {
      dispatch(setSelectedTemplate(template));
      dispatch(setShowNoShowEmailModal(true));

      const { _id: templateId } = template;
      const payload = { templateId, patientId: profile.patientId };
      dispatch(setSelectedDocument(payload));
    } catch (error) {
      showToast({ message: error.message, type: "error" });
    } finally {
      dispatch(setIsDownloading(false));
    }
  };

  return {
    anchorRef,
    currentUser,
    nowShowLetters,
    letterTemplates,
    noShowAnchorRef,
    isNoShowLetterMenu,
    isLetterTemplateMenu,

    dispatch,
    handleTemplateSelection,
    handleNoShowTemplateSelection,
  };
};

export default useDocumentTitle;
